module.exports = __webpack_public_path__ + "img/sweep.bfdff30a.svg";